import { useMemo } from "react";
import styles from "./index.module.scss";
import { formatPrice } from "../../../../../utils";

export default function Price({ product }) {
  const catalog = product.CATALOG;

  const isAlailable = useMemo(() => {
    return catalog.AVAILABLE;
  }, [catalog]);

  const price = useMemo(() => {
    return catalog.MIN_PRICE;
  }, [catalog]);

  const noDiscoutPrice = useMemo(() => {
    return catalog.PRICE;
  }, [catalog]);

  const edostMinPriceCorrected = useMemo(() => {
    return 0;
  }, [catalog]);

  const priceWithCity = useMemo(() => {
    return price + edostMinPriceCorrected;
  }, [edostMinPriceCorrected]);

  return (
    <div>
      <div
        className={styles.Price}
        itemProp="offers"
        itemScope
        itemType="http://schema.org/Offer"
      >
        {isAlailable && noDiscoutPrice > price && (
          <div className={styles.BeforeValue}>{noDiscoutPrice} руб</div>
        )}
        {!isAlailable && (
          <div className={styles.LastValue}>Последная цена:</div>
        )}
        <div className={styles.Value}>
          <span>
            <span itemProp="price">{formatPrice(priceWithCity)}</span> руб
          </span>
        </div>
      </div>
      <div className={styles.PriceInfo}>*стоимость товара без установки</div>
    </div>
  );
}
